import type { BaseDataPoint } from "./charts";

type VoltageValues = Pick<BaseDataPoint, "yValue" | "chartYValue" | "baselineValue">;

/** Reference limits for a known nominal service voltage; unknown services omit them. */
export function voltageReferenceLines(nominalVoltage = 240) {
  if (!Number.isFinite(nominalVoltage) || nominalVoltage <= 0) return undefined;
  return [1.05, 0.95].map((factor) => {
    const value = Math.round(nominalVoltage * factor);
    return { value, label: `${value} V` };
  });
}

/** Preserve nominal context while fitting every finite line and envelope value with 4 V clearance. */
export function voltageYDomain(data: readonly VoltageValues[]): [number, number];
export function voltageYDomain(data: readonly VoltageValues[], nominalVoltage: number): [number, number] | undefined;
export function voltageYDomain(data: readonly VoltageValues[], nominalVoltage = 240): [number, number] | undefined {
  const limits = voltageReferenceLines(nominalVoltage);
  if (!limits) return undefined;
  let lower = Math.min(limits[1].value - 4, nominalVoltage - 12);
  let upper = Math.max(limits[0].value + 4, nominalVoltage + 12);
  for (const point of data) {
    for (const value of [point.yValue, point.chartYValue, point.baselineValue]) {
      if (typeof value !== "number" || !Number.isFinite(value)) continue;
      lower = Math.min(lower, value - 4);
      upper = Math.max(upper, value + 4);
    }
  }
  return [lower, upper];
}
